module.exports = __webpack_public_path__ + "img/catalog-category-aksessuary-dlya-ochkov.ac1d216.png?v=1764327952164";